import * as React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const Header = ({ path }) => {
  const { LogoImage } = useStaticQuery(
    graphql`
      query {
        LogoImage: file(relativePath: {eq: "logo.jpg"}) {
          childImageSharp {
            gatsbyImageData(quality: 100, layout: CONSTRAINED, width: 253, height: 94)
          }
        }
      }
    `
  )
  return (
    <header>
      <div className="pt-4 w-full">
        <div className="max-w-6xl mx-auto px-4 mb-4">
          <div className="gap-6 flex justify-between items-center lg:flex-row flex-col">
            <div className="logo">
              <Link to="/">
                <GatsbyImage image={getImage(LogoImage)} alt={`Home - Window Caulking`} loading="eager" />
              </Link>
            </div>
            <div className="flex sm:gap-8 gap-5 sm:flex-row flex-col items-center">
              <a href="tel:6475571116" className="text-gray-500 no-underline hover:text-sky-400 flex gap-2 items-center"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="#1c81c5"><path d="M20 22.621l-3.521-6.795c-.008.004-1.974.97-2.064 1.011-2.24 1.086-6.799-7.82-4.609-8.994l2.083-1.026-3.493-6.817-2.106 1.039c-7.202 3.755 4.233 25.982 11.6 22.615.121-.055 2.102-1.029 2.11-1.033z" /></svg> 647-557-1116</a>
              <a href="mailto:info@windowcaulking.ca" className="text-gray-500 no-underline hover:text-sky-400 flex gap-2 items-center"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="#1c81c5"><path d="M0 3v18h24v-18h-24zm21.518 2l-9.518 7.713-9.518-7.713h19.036zm-19.518 14v-11.817l10 8.104 10-8.104v11.817h-20z" /></svg> info@windowcaulking.ca</a>
              <p className="text-gray-500 flex gap-2 items-center mb-0"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="#1c81c5"><path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm1 12v-6h-2v8h7v-2h-5z" /></svg> Mon - Sat : 9am to 7pm</p>
            </div>
          </div>
        </div>
        <div className="nav bg-sky-600 py-4 lg:block hidden">
          <div className="max-w-6xl mx-auto px-4">
            <ul className="flex m-0 p-0 items-center">
              <li className="mb-0"><Link to="/" className={`text-white font-normal uppercase no-underline py-5 hover:bg-red-500 ${path==='/' && ' bg-red-500'}`}>home</Link></li>
              <li className="mb-0"><Link to="/about" className={`text-white font-normal uppercase no-underline hover:bg-red-500 ${path==='/about/' && ' bg-red-500'}`}>about</Link></li>
              <li className="mb-0"><Link to="/services" className={`text-white font-normal uppercase no-underline hover:bg-red-500 ${path==='/services/' && ' bg-red-500'}`}>services</Link></li>
              <li className="mb-0"><Link to="/promotions" className={`text-white font-normal uppercase no-underline hover:bg-red-500 ${path==='/promotions/' && ' bg-red-500'}`}>promotions</Link></li>
              <li className="mb-0"><Link to="/online-quote" className={`text-white font-normal uppercase no-underline hover:bg-red-500 ${path==='/online-quote/' && ' bg-red-500'}`}>online quote</Link></li>
              <li className="mb-0"><Link to="/contact-us" className={`text-white font-normal uppercase no-underline hover:bg-red-500 ${path==='/contact-us/' && ' bg-red-500'}`}>contact us</Link></li>
            </ul>
          </div>
        </div>

        <div className="lg:hidden block">
          <input type="checkbox" className="openSideMenu" id="openSideMenu" />
          <label htmlFor="openSideMenu" className="sideIconToggle" onClick="openNav()">
            <div className="spinner diagonal part-1"></div>
            <div className="spinner horizontal"></div>
            <div className="spinner diagonal part-2"></div>
          </label>
          <div id="sideMenu">
            <ul className="flex flex-col m-0 p-0 mt-12">
              <li className="flex items-center mb-0 text-black"><Link to="/" className="text-base hover:text-sky-600 text-black capitalize no-underline px-5 leading-10">home</Link></li>
              <li className="flex items-center mb-0 text-black"><Link to="/about" className="text-base hover:text-sky-600 text-black capitalize no-underline px-5 leading-10">about</Link></li>
              <li className="flex items-center mb-0 text-black"><Link to="/services" className="text-base hover:text-sky-600 text-black capitalize no-underline px-5 leading-10">services</Link></li>
              <li className="flex items-center mb-0 text-black"><Link to="/promotions" className="text-base hover:text-sky-600 text-black capitalize no-underline px-5 leading-10">promotions</Link></li>
              <li className="flex items-center mb-0 text-black"><Link to="/online-quote" className="text-base hover:text-sky-600 text-black capitalize no-underline px-5 leading-10">online quote</Link></li>
              <li className="flex items-center mb-0 text-black"><Link to="/contact-us" className="text-base hover:text-sky-600 text-black capitalize no-underline px-5 leading-10">contact us</Link></li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  )
}
export default Header